import { matchPath } from 'react-router-dom';
import type { Route } from './routes';

/**
 * A route pattern that can optionally end with `/*` for prefix matching.
 *
 * - `'/workspaces/:workspaceId/journeys/campaigns'` — exact match only
 * - `'/workspaces/:workspaceId/journeys/campaigns/*'` — matches any sub-path
 */
export type RoutePattern = Route | `${Route}/*`;

/**
 * Check if a pathname matches any of the given route patterns.
 *
 * @example
 * matchRoutes('/workspaces/123/journeys/campaigns/42/overview', [
 *   '/workspaces/:workspaceId/journeys/campaigns/:campaignId/*',
 * ])
 * // => true
 */
export function matchRoutes(pathname: string, patterns: RoutePattern[]): boolean {
  return patterns.some((pattern) => matchPath(pattern, pathname) != null);
}
